import React from 'react'

function BrokerageLogo({kind}) {
  switch (kind) {
    case 'compass':
      return (
        <div className="hlm-brokerage-compass">
          <svg width="26" height="26" viewBox="0 0 28 28" aria-hidden="true">
            <circle cx="14" cy="14" r="13" stroke="#0e2433" strokeWidth="1.5" fill="none" />
            <path d="M14 6 L17 14 L14 22 L11 14 Z" fill="#0e2433" />
          </svg>
          <span>COMPASS</span>
        </div>
      )
    case 'cb':
      return (
        <div className="hlm-brokerage-cb">
          <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden="true">
            <rect x="2" y="2" width="28" height="28" stroke="#0a4d7a" strokeWidth="1.5" fill="#fff" />
            <text x="16" y="22" textAnchor="middle" fontFamily="Georgia, serif" fontWeight="700" fontSize="14" fill="#0a4d7a">
              CB
            </text>
          </svg>
          <div>
            <span>COLDWELL</span>
            <span>BANKER</span>
          </div>
        </div>
      )
    case 'sothebys':
      return (
        <div className="hlm-brokerage-sothebys">
          <div>SOTHEBY&rsquo;S</div>
          <div>INTERNATIONAL REALTY</div>
        </div>
      )
    case 'kw':
      return (
        <div className="hlm-brokerage-kw">
          <svg width="30" height="30" viewBox="0 0 32 32" aria-hidden="true">
            <rect width="32" height="32" rx="2" fill="#c8102e" />
            <text x="16" y="22" textAnchor="middle" fontFamily="Georgia, serif" fontWeight="700" fontSize="14" fill="#fff">
              KW
            </text>
          </svg>
          <div>
            <span>Keller Williams</span>
            <span>REALTY INTERNATIONAL</span>
          </div>
        </div>
      )
    case 'bhhs':
      return (
        <div className="hlm-brokerage-bhhs">
          <svg width="32" height="32" viewBox="0 0 34 34" aria-hidden="true">
            <rect width="34" height="34" rx="2" fill="#552448" />
            <path d="M8 24 L17 8 L26 24 Z" fill="none" stroke="#fff" strokeWidth="1.5" />
          </svg>
          <div>
            <span>BERKSHIRE HATHAWAY</span>
            <span>HomeServices</span>
          </div>
        </div>
      )
    case 'douglas':
      return (
        <div className="hlm-brokerage-douglas">
          <div>DOUGLAS</div>
          <div>ELLIMAN</div>
        </div>
      )
    case 'exp':
      return (
        <div className="hlm-brokerage-exp">
          <svg width="36" height="22" viewBox="0 0 38 22" aria-hidden="true">
            <path d="M2 11 Q10 2 18 11 Q26 20 36 11" stroke="#0a4d7a" strokeWidth="2.5" fill="none" strokeLinecap="round" />
          </svg>
          <span>
            <em>e</em>XpRealty
          </span>
        </div>
      )
    case 'corcoran':
      return <div className="hlm-brokerage-corcoran">CORCORAN</div>
    default:
      return null
  }
}

const brokerages = [
  {name: 'Compass', kind: 'compass'},
  {name: 'Coldwell Banker', kind: 'cb'},
  {name: "Sotheby's", kind: 'sothebys'},
  {name: 'Keller Williams', kind: 'kw'},
  {name: 'Berkshire Hathaway', kind: 'bhhs'},
  {name: 'Douglas Elliman', kind: 'douglas'},
  {name: 'eXp Realty', kind: 'exp'},
  {name: 'Corcoran', kind: 'corcoran'},
]

function TopBrokeragesV2() {
  return (
    <section className="hlm-brokerages">
      <div className="hlm-container hlm-center">
        <div className="hlm-eyebrow">Trusted by top brokerages</div>
      </div>
      <div className="hlm-marquee">
        <div className="hlm-marquee-track">
          {[...brokerages, ...brokerages].map((b, index) => (
            <div className="hlm-brokerage" key={`${b.kind}-${index}`} title={b.name}>
              <BrokerageLogo kind={b.kind} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TopBrokeragesV2
